module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_heart_mask.1a464248.png";